import { useState } from 'react'
import { TabPanel, TabView } from 'primereact/tabview'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

// local imports
import HealthServiceCharts from './HealthServiceCharts'
import CoiffeurServiceCharts from './CoiffeurServiceCharts'
import GymServiceCharts from './GymServiceCharts'
import LactationServiceCharts from './LactationServiceCharts'

export default function OnCampusChartContainerPage(props: any) {
  const { t } = useTranslation()
  const { isCoiffeurServiceExist, isGymServiceExist, isHealthServiceExist, isLactationServiceExist } =
    props.campusVisible || {}

  const setTabIndex = () => (isHealthServiceExist ? 0 : isGymServiceExist ? 1 : isCoiffeurServiceExist ? 2 : 3)
  const [activeIndex, setActiveIndex] = useState(() => setTabIndex())

  return (
    <InnerTabWrapper>
      <TabView renderActiveOnly activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        {isHealthServiceExist && (
          <TabPanel header={t('dashboard.on-campus-tabs.health-service-res')}>
            <HealthServiceCharts
              selectedFirms={props.selectedFirms}
              startDate={props.startDate}
              endDate={props.endDate}
              firmList={props.firmList}
              userInfo={props.userInfo}
            />
          </TabPanel>
        )}

        {isGymServiceExist && (
          <TabPanel header={t('dashboard.on-campus-tabs.gym-res')}>
            <GymServiceCharts
              selectedFirms={props.selectedFirms}
              startDate={props.startDate}
              endDate={props.endDate}
              firmList={props.firmList}
              userInfo={props.userInfo}
            />
          </TabPanel>
        )}

        {isCoiffeurServiceExist && (
          <TabPanel header={t('dashboard.on-campus-tabs.coiffeur-res')}>
            <CoiffeurServiceCharts
              selectedFirms={props.selectedFirms}
              startDate={props.startDate}
              endDate={props.endDate}
              firmList={props.firmList}
              userInfo={props.userInfo}
            />
          </TabPanel>
        )}

        {isLactationServiceExist && (
          <TabPanel header={t('dashboard.on-campus-tabs.lactation-res')}>
            <LactationServiceCharts
              selectedFirms={props.selectedFirms}
              startDate={props.startDate}
              endDate={props.endDate}
              firmList={props.firmList}
              userInfo={props.userInfo}
            />
          </TabPanel>
        )}
      </TabView>
    </InnerTabWrapper>
  )
}

const InnerTabWrapper = styled.div`
  margin: -16px -8px;
`
